var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5674 14.8828H37.3508V26.9303C37.3508 26.9303 34.034 30 25.0001 30C15.9661 30 12.5674 26.9303 12.5674 26.9303V14.8828Z",
    fill: "#8894AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6758 5.63412L41.8551 13.0121C43.0253 13.5457 43.0253 15.208 41.8551 15.7416L25.6758 23.1196C25.2805 23.2999 24.8264 23.2999 24.4311 23.1196L8.25171 15.7416C7.08152 15.208 7.08152 13.5457 8.25171 13.0121L24.4311 5.63412C24.8264 5.45384 25.2805 5.45384 25.6758 5.63412Z",
    fill: "#BCC4D6",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7676 13.6211C23.6295 13.6211 23.5176 13.733 23.5176 13.8711C23.5176 14.0092 23.6295 14.1211 23.7676 14.1211V13.6211ZM41.7197 29.9992C41.7197 30.7356 42.3167 31.3325 43.053 31.3325C43.7894 31.3325 44.3864 30.7356 44.3864 29.9992C44.3864 29.2628 43.7894 28.6659 43.053 28.6659C42.3167 28.6659 41.7197 29.2628 41.7197 29.9992ZM23.7676 14.1211H41.053V13.6211H23.7676V14.1211ZM42.803 15.8711V29.9992H43.303V15.8711H42.803ZM41.053 14.1211C42.0195 14.1211 42.803 14.9046 42.803 15.8711H43.303C43.303 14.6285 42.2957 13.6211 41.053 13.6211V14.1211Z",
    fill: "#8894AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.2db024629194a2fc2322c000e2ba76dd.svg";
export { ForwardRef as ReactComponent };